import {derived} from 'svelte/store';
import {api} from '../lib/api'
import user from './user';

export default projectsStore();

function projectsStore(){
    let store = derived(user,async ($user,set)=>{
        
        if($user && $user._id){
            set(await api.get(`/project/list/${$user._id}`));
        }else{
            set([]);
        }
    },[])

    return store;
}